import { Box } from "@mui/material";
import { useCallback, useRef, useState } from "react";
import { Form } from "@unform/web";
import { FormHandles } from "@unform/core";
import { InputMoney } from "../../../../../Components/Atoms/InputMoney";
import { ConfirmDialogModal } from "../../../../../Components/Atoms";
import { Header } from "../../styles";
import SaldoCard from "../SaldoCard";
import CustomButton from "../../CustomButton";
import { convertToCents, formatCurrency } from "../../../../../Utils/formatters";

type Props = {
  name: string;
  monthlyFee: number;
  onSubmit: (data: any) => void;
};

const MensalidadeSection = ({ name, monthlyFee, onSubmit }: Props) => {
  const formRef = useRef<FormHandles>(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [confirmText, setConfirmText] = useState<string>("Confirmar continuação");
  const [confirmDescription, setConfirmDescription] = useState<string>("Tem certeza que deseja continuar?");

  const handleConfirmAndSubmit = () => {
    setOpenConfirm(false);
    formRef.current?.submitForm();
  };

  const handleOpenConfirm = useCallback(() => {
    const data: any = formRef.current?.getData?.() ?? {};
    const newCents = convertToCents(data?.value ?? 0);

    setConfirmText("Confirmar alteração de mensalidade");

    if (newCents === 0) {
      setConfirmDescription("Você confirma que este ponto de venda não terá mensalidade?");
    } else if (newCents > 0) {
      const oldValue = formatCurrency(monthlyFee, "BRL", 2);
      const newValue = formatCurrency(newCents, "BRL", 2);
      setConfirmDescription(`O valor era de ${oldValue} e agora você está mudando para ${newValue}.\nDeseja continuar?`);
    } else {
      setConfirmDescription("Tem certeza que deseja continuar?");
    }

    setOpenConfirm(true);
  }, [monthlyFee]);

  return (
    <>
      <SaldoCard title={"Mensalidade do ponto de venda: "} name={name} amount={monthlyFee} />

      <Box>
        <Header>
          <h6>Quanto você deseja cobrar de mensalidade?</h6>
        </Header>

        <Form ref={formRef} onSubmit={onSubmit}>
          <InputMoney />
          <CustomButton variant="contained" type="button" onClick={handleOpenConfirm}>
            Continuar
          </CustomButton>
          <p style={{ paddingTop: "10px" }}>Informe R$ 0.00 para não cobrar mensalidade</p>
        </Form>
      </Box>

      <ConfirmDialogModal
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        text={confirmText}
        description={confirmDescription}
        refreshAction={handleConfirmAndSubmit}
      />
    </>
  );
};

export default MensalidadeSection;
